function Checkbox(props) {
  const id = props.id || 'terms';

  return (
    <div className="form-check mb-4">
      <input className="form-check-input" type="checkbox" id={id}
        checked={props.checked || false} onChange={props.onChange} />
      <label className="form-check-label" htmlFor={id}>
        {props.text}
      </label>
    </div>
  );
}

export default Checkbox;
